<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Set`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.52445 23H15.283C17.118 23 18.8251 22.0142 19.7411 20.4263L23.1204 14.5752C24.0364 12.9873 24.0364 11.0127 23.1204 9.42485L19.7411 3.57369C18.8251 1.98585 17.1151 1 15.283 1H8.52445C6.69233 1 4.98235 1.98585 4.06629 3.57369L0.687046 9.42776C-0.229015 11.0156 -0.229015 12.9873 0.687046 14.5752L4.06629 20.4263C4.98235 22.0142 6.69233 23 8.52445 23ZM6.24739 4.83C6.7156 4.01863 7.59095 3.51263 8.52736 3.51263V3.50972H15.2859C16.2223 3.50972 17.0976 4.01572 17.5658 4.82709L20.9451 10.6783C21.4133 11.4925 21.4133 12.5016 20.9451 13.313L17.5658 19.1642C17.0976 19.9755 16.2223 20.4816 15.2859 20.4816H8.52736C7.59095 20.4816 6.7156 19.9755 6.24739 19.1642L2.86814 13.313C2.39994 12.5016 2.39994 11.4925 2.86814 10.6812L6.24739 4.83ZM6.4248 12.0016C6.4248 15.0232 8.88218 17.4834 11.9066 17.4834C14.9282 17.4834 17.3885 15.0232 17.3885 12.0016C17.3885 8.98006 14.9282 6.51978 11.9066 6.51978C8.88509 6.51978 6.4248 8.97716 6.4248 12.0016ZM8.94034 11.9987C8.94034 10.3643 10.2694 9.0324 11.9066 9.0324C13.541 9.0324 14.8729 10.3643 14.8729 11.9987C14.8729 13.6331 13.541 14.965 11.9066 14.965C10.2723 14.965 8.94034 13.636 8.94034 11.9987Z"/></svg>
</template>
<script>

export default {
  name: 'IconSet',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
